import { AxiosResponse } from 'axios';
import { RestServiceConnection } from '../restServiceConnection';

const ENDPOINT = '/group-code';

export class GroupCodeService extends RestServiceConnection {

    assignContracts = async (values: {
        contractIds: string[];
        orderId: string;
        groupCodeId?: string;
        useSameGroupCodeForSameOrganiser?: boolean;
    }) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/assign-contracts',
            data: values,
            headers: { "Content-Type": "application/json" }
        }, true) as AxiosResponse;
        return this;
    }

    unlinkContract = async (values: { contractId: string }) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/unlink-contract',
            data: values,
            headers: { "Content-Type": "application/json" }
        }, true) as AxiosResponse;
        return this;
    }

    unlinkContracts = async (values: { contractIds: string[] }) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/unlink-contracts',
            data: values,
            headers: { "Content-Type": "application/json" }
        }, true) as AxiosResponse;
        return this;
    }

    listByOrder = async (values: { orderId: string }) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list-by-order',
            data: values,
            headers: { "Content-Type": "application/json" }
        }, true) as AxiosResponse;
        return this;
    }

    editCode = async (values: { groupCodeId: string; code: string; startDate: string; endDate: string }) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/edit-code',
            data: values,
            headers: { "Content-Type": "application/json" }
        }, true) as AxiosResponse;
        return this;
    }

    delete = async (values: { groupCodeId: string }) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/delete',
            data: values,
            headers: { "Content-Type": "application/json" }
        }, true) as AxiosResponse;
        return this;
    }
}
